import styled from "styled-components";

export const ProgressBarWrapper = styled.div`
  position: relative;
  width: 100%;
`;
